import React, { useRef, useState } from 'react'

import InputText from '../input-text/input-text'
import inputProptypes from '../input-proptype'
import * as CPFUtility from '@components/utilities/cpf-utility'
import { useInitialValueToValidation } from '../custom-hooks'
import useEvents from '@components/utilities/event-hooks-utility'

const InputCPF = ({ value, onChange, onBlur, errorMessage, required, ...rest }) => {
  const [currentMessage, setCurrentMessage] = useState(errorMessage)
  const [inputValue, setInputValue] = useState(value || '')

  const thisInput = useRef(null)
  const defaultEvents = useEvents(thisInput)

  const validateCPF = (maskedCPF, unmaskedCPF) => {
    setCurrentMessage('')
    if (!required && !unmaskedCPF.length) return
    if (maskedCPF.length !== 14) return setCurrentMessage('CPF incompleto.')

    const isValidCPF = CPFUtility.validateCPF(unmaskedCPF)
    if (!isValidCPF) return setCurrentMessage('CPF inválido.')
  }

  const handleOnChange = defaultEvents.useOnChange(async ({ value, id, name }) => {
    const { maskedCPF, unmaskedCPF } = CPFUtility.maskCPF(value)

    setInputValue(maskedCPF)
    if (onChange) await onChange({ maskedValue: maskedCPF, value: unmaskedCPF, id, name })

    return maskedCPF
  })

  const handleOnBlur = value => {
    const { maskedCPF, unmaskedCPF } = CPFUtility.maskCPF(value)

    validateCPF(maskedCPF, unmaskedCPF)
    if (onBlur) onBlur(unmaskedCPF, maskedCPF)
  }

  let inputProps = {
    type: 'tel',
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    errorMessage: currentMessage,
    maxLength: 14,
    value: inputValue,
    onKeyUp: defaultEvents.onKeyUp,
    required,
    inputRef: thisInput,
    ...rest,
  }

  useInitialValueToValidation(value, () => {
    if (!value) return

    const { maskedCPF, unmaskedCPF } = CPFUtility.maskCPF(value)

    validateCPF(maskedCPF, unmaskedCPF)
    setInputValue(maskedCPF)
  })

  return <InputText {...inputProps} />
}

InputCPF.propTypes = inputProptypes

export default InputCPF
